import React from 'react';

import CustomCards from './CutomCards.jsx';

import { ReactComponent as PointsToSendIcon } from './../../../assets/svg/pointstosend.svg';
import { ReactComponent as RecipientIcon } from './../../../assets/svg/recipientOne.svg';
import { ReactComponent as RewardIcon } from './../../../assets/svg/rewardOne.svg';

import './style.scss';

const RewardPointsAndBonus = ({ rewardPointsBonus }) => {
	return (
		<div className="rewards-points d-card height-equal mb-0">
			<div className="d-card-head">
				<h4 className="d-title-no-case">Earned Points & Bonuses</h4>
			</div>
			<div className="reward-point-boxes">
				<CustomCards
					Icon={PointsToSendIcon}
					customCardsClassName="reward-bonus"
					cardColor="#14D6D3"
					pointAmount={rewardPointsBonus?.pointsToSend}
					cardTitle={'Total Points'}
				/>
				<CustomCards
					Icon={RewardIcon}
					cardColor="#e75da7"
					customCardsClassName="reward-bonus"
					pointAmount={rewardPointsBonus?.badges}
					cardTitle={'Badges'}
				/>
				<CustomCards
					Icon={RecipientIcon}
					cardColor="#813ae2"
					customCardsClassName="reward-bonus"
					pointAmount={rewardPointsBonus?.shoutOuts}
					cardTitle={'Shoutouts'}
				/>
			</div>
		</div>
	);
};

export default RewardPointsAndBonus;
